export default {"src":"/_next/static/media/0x8f3cf7ad23cd3cadbd9735aff958023239c6a063.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};